import axios from "axios";
import { API_BASE_URL } from "./utils/constant";

const axiosUserInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem("token");
    if (!refreshToken) throw new Error("No refresh token found");

    const response = await axiosUserInstance.post(
      "/auth/refresh",
      {
        refreshToken: refreshToken,
      },
      { withCredentials: true }
    );

    if (!response.data.success) throw new Error("Refresh failed");

    const newAccessToken = response.data.accessToken;

    localStorage.setItem("token", newAccessToken);

    return newAccessToken;
  } catch (err) {
    console.error("Failed to refresh access token:", err);
    throw err;
  }
}

axiosUserInstance.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};

    if (!config.skipAuth) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosUserInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const newAccessToken = await refreshAccessToken();

        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axiosUserInstance(originalRequest);
      } catch (refreshError) {
        console.error(" Refresh token expired, logging out...");
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("biome_page_font");
        document.documentElement.style.removeProperty("--page-font");
        if (window.location.pathname !== "/auth/login") {
          window.location.href = "/auth/login";
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosUserInstance;
